<template>
  <div class="group ml-3 mb-3">
    <div class="actions d-flex align-items-center mb-3">

      <div class="opPicker">
        <a
          v-for="option in groupOptions"
          :key="option.key"
          class="main-action"
          :class="option.value !== group.key ? 'second-action' : null"
          @click="group.key = option.value"
        >
          {{option.text}}
        </a>
      </div>

      <a
        class="icon-btn add ml-2 overflow-btn"
        :id="`group-options-overflow-${groupUUID}`"
        @click.stop="show_options()"
        v-tooltip="{ content: `Add group/condition`, delay: 200 }"
      ></a>

      <a
        v-if="!root"
        class="icon-btn delete ml-1"
        @click="$emit('remove')"
        v-tooltip="{ content: `Delete group`, delay: 200 }"
      ></a>
    </div>

    <div class="content">
      <div v-for="(child, i) of groupChildren" :key="`group-child-${i}`">
        <templateBuilderGroup
          v-if="child.type === NodeTypes.operation"
          :group="child"
          :class="i > 0 ? 'mt-3' : null"
          @remove="removeChild(i)"
        />
        <TemplateBuilderCondition
          v-else-if="child.type === NodeTypes.condition"
          :condition="child"
          @remove="removeChild(i)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {Op, NodeTypes, ConditionOperators} from '../utils/ProjectTemplates'
import TemplateBuilderCondition from './TemplateBuilderCondition'
import { v4 as uuidV4 } from 'uuid';

export default {
  name: "TemplateBuilderGroup",
  components: {
    TemplateBuilderCondition
  },
  props: {
    group: {
      type: Object,
      default: () => ({})
    },
    root: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      NodeTypes
    }
  },
  methods: {
    removeChild(childIndex){
      this.groupChildren.splice(childIndex, 1)
    },
    addChildGroup(){
      this.group.value.push({
        key: Op.and,
        type: NodeTypes.operation,
        value: []
      })
    },
    addChildCondition(){
      this.group.value.push({
        key: null,
        type: NodeTypes.condition,
        operator: ConditionOperators.equal,
        value: null
      })
    },
    show_options() {
      this.$store.dispatch('setOverflowDropShowing', false);

      const rect = document
        .querySelector(`#group-options-overflow-${this.groupUUID}`)
        .getBoundingClientRect();

      const {left: mainViewLeft} = document.querySelector('#main-view').getBoundingClientRect();

      this.$store.dispatch('setOverflowDropPosition', {
        top: rect.top,
        left: rect.left + mainViewLeft,
      });

      this.$store.dispatch('setOverflowOptions', [{
        label: 'Add group',
        handler: this.addChildGroup
      },
      {
        label: 'Add condition',
        handler: this.addChildCondition
      }]);
      this.$store.dispatch('setOverflowItemId', this.groupUUID);

      setTimeout(() => {
        this.$store.dispatch('setOverflowDropShowing', true);
      }, 100);
    },
  },
  computed: {
    groupOptions() {
      return Object.keys(Op).map((key) => ({
        text: key.toUpperCase(),
        value: Op[key]
      }))
    },
    groupType: {
      get: () => {
        return this.group.key
      },
      set: (val) => {
        this.group.key = val
      }
    },
    groupChildren() {
      return this.group.value
    },
    groupUUID() {
      return uuidV4()
    }
  }
}
</script>

<style lang="scss">

.group{
  &:before{
    border-left: 1px dashed #9DA1A6;
  }
}

.opPicker{
  display: flex;

  a{
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 50px;
    padding: 5px;
    margin: 0 !important;
    border-radius: 0;
    font-weight: 400;

    &:first-child{
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    &:last-child{
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
}

.icon-btn {
  border-radius: 15px;
  width: 30px;
  height: 30px;
  margin-right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-repeat: no-repeat;

  &.add {
    background-image: url(~@/assets/icons/plus-grey.svg);
    background-size: 16px 16px;
    background-position: center;
  }

  &.delete {
    background-image: url(~@/assets/icons/trash.svg);
    background-size: 30px 30px;
    background-position: top left;
  }

  .overflow-btn {
    position: relative;
  }
}
</style>
